import clx from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

type SuccessOrFailureProps = {
  leftNode?: ReactNode;
  reverse?: boolean;
};

const SuccessOrFailure = ({ children, leftNode, reverse }: PropsWithChildren<SuccessOrFailureProps>) => (
  <div className={clx('flex md:flex-row gap-8 items-center', reverse ? 'flex-col' : 'flex-col-reverse')}>
    {leftNode || (
      <img
        alt=""
        className="max-w-[280px] md:max-w-[550px] w-full"
        height={550}
        src="/emotes/cry-brassbug.png"
        width={550}
      />
    )}
    <div className="flex flex-col gap-8 grow">{children}</div>
  </div>
);

export default SuccessOrFailure;
